/* tslint:disable:jsx-no-lambda */
import { MUIButton, MUICheckBox, MUISelect, MUITextField } from '@abb/arcadia-ui-react';
import * as React from 'react';
import { Option } from '@module/shared/selectOption';
import { IUserFilterValue } from './models';

type OptionValues = any;

export interface IUserFilterProps {
  filter: IUserFilterValue;
  onFilterApply: (filter: IUserFilterValue) => void;
  onClear: () => void;
}

interface IUserFilterState {
  filter: IUserFilterValue;
  countries: Array<Option<OptionValues>>;
}

export class UserFilter extends React.Component<IUserFilterProps, IUserFilterState> {
  constructor(props: any) {
    super(props);

    this.state = {
      filter: props.filter,
      countries: require('./Country.json')
    };
  }

  componentWillReceiveProps(nextProps: IUserFilterProps) {
    this.setState({ filter: nextProps.filter });
  }

  render() {
    const adminOptions = [{ id: 'true', name: 'Admin' }, { id: 'false', name: 'Non-Admin' }];
    const scopeValues = this.state.countries.map((value: any) => ({ id: value.countryID, name: value.countryID }));

    return (
      <div className='panel panel-default'>
        <div className='panel-body'>
          <div id='pbFilterForm'>
            <fieldset>
              <legend>FILTER USERS</legend>

              <div className='row'>
                <div className='col-lg-12'>
                  <MUITextField
                    name='email'
                    label='Email Address'
                    isRequired={false}
                    size={32}
                    placeholder='Email'
                    value={this.state.filter ? this.state.filter.email : ''}
                    onChange={this.handleTextInputChange} />
                </div>
              </div>

              <div className='row'>
                <div className='col-lg-12'>
                  <MUISelect
                    name='adminFilter'
                    placeholder='Select One'
                    label='Admin'
                    size={32}
                    clearable={true}
                    dropdownLOV={adminOptions}
                    selectedItem={this.state.filter.isAdmin === undefined ? [] : [String(this.state.filter.isAdmin)]}
                    onChange={this.handleAdminChange} />
                </div>
              </div>

              <div className='row'>
                <div className='col-lg-12'>
                  <MUISelect
                    name='scopesFilter'
                    placeholder='Select One'
                    label='Scopes'
                    size={32}
                    dropdownLOV={scopeValues}
                    selectedItem={this.state.filter.scopes || []}
                    multiSelect={true}
                    isDisabled={this.state.filter.allScopes}
                    onChange={this.handleScopeChange} />
                </div>
              </div>

              <div className='row'>
              <div className='col-lg-12'>
                <MUICheckBox
                  label='Scoped by all countries'
                  checked={this.state.filter.allScopes}
                  handleToggle={this.handleCheckbox}
                />
              </div>
            </div>

              <div className='row'>
                <div className='col-lg-6' />
                <div className='col-lg-6 form-group text-right'>
                  <MUIButton variant='discreet' size={32} label='Clear' onClickButton={this.props.onClear} />{' '}
                  <MUIButton variant='primary' size={32} label='Apply' onClickButton={this.handleApply} />
                </div>
              </div>

            </fieldset>
          </div>
        </div>
      </div>
    );
  }

  handleAdminChange = (value: any) => {
    const arr = Array.isArray(value) ? value : [];
    if (arr.length === 0) {
      this.setState((prevState: any) => ({ filter: { ...prevState.filter, isAdmin: undefined } }));
      return;
    }
    const id = typeof arr[0] === 'object' && arr[0] !== null ? arr[0].id : arr[0];
    this.setState((prevState: any) => ({ filter: { ...prevState.filter, isAdmin: String(id) === 'true' } }));
  }

  handleCheckbox = (_e: any, value?: boolean) => {
    this.setState((prevState: any) => ({ filter: { ...prevState.filter, allScopes: value ?? !prevState.filter.allScopes } }));
  }

  handleTextInputChange = (value: string) => {
    this.setState((prevState: any) => ({ filter: { ...prevState.filter, email: value } }));
  }

  handleScopeChange = (value: any) => {
    const selectedScopes: string[] = Array.isArray(value)
      ? value.map((v: any) => (typeof v === 'object' && v !== null ? v.id : v))
      : [];
    this.setState((prevState: any) => ({ filter: { ...prevState.filter, scopes: selectedScopes } }));
  }

  handleApply = () => {
    if (JSON.stringify(this.props.filter) !== JSON.stringify(this.state.filter)) {
      this.props.onFilterApply(this.state.filter);
    }
  }
}
